import { api } from '@/lib/api'

export interface WaarderingsKpi {
  waarderingsom: number
  deductiesom: number
  waarderingsom_financierbaar: number
}

export interface OpenFactuur {
  factuurnr: string
  bedrag: number
}

export interface BanksheetOut {
  liggend: number
  zeilend: number
  totaal: number
  emballage: number
  verpakking: number
  overig: number
  crediteuren_open: number
  norf: number
  incourant: number
  vrije_voorraad: number
  financierbaar: number
  fin_pct_voorraad: number
  fin_pct_emballage: number
  fin_pct_verpakking: number
  fin_pct_overig: number
  min_houdbaarheidsdagen: number
}

export interface ThtBucketOut {
  klasse: string
  waarde: number
  partijen: number
  pct: number
}

export interface VoorraadsamenstellingOut {
  aantal_partijen: number
  totaal_eenheden: number
}

export interface DashboardOut {
  organisation_id: number
  organisation_naam: string
  bederfelijke_waar_actief: boolean
  kpi: WaarderingsKpi
  banksheet: BanksheetOut
  voorraadsamenstelling: VoorraadsamenstellingOut
  tht_buckets: ThtBucketOut[]
  open_facturen: OpenFactuur[]
}

export async function fetchDashboard(orgId: number): Promise<DashboardOut> {
  const { data } = await api.get<DashboardOut>(`/api/dashboard/${orgId}`)
  return data
}
